import { Box, Flex, Text } from "@chakra-ui/core";
import React from "react";

import { Link } from "react-router-dom";
export const MobileNav = ({ menu }) => {
  const [showSubMenu, setShowSubMenu] = React.useState(false);

  const onExpandNav = () => setShowSubMenu(!showSubMenu);

  return (
    <Flex onClick={onExpandNav} direction='column' cursor='pointer' w='100%'>
      <Link to={menu.path}>
        <Flex align='center' mt='2'>
          <Text
            fontSize={["lg", "16px"]}
            color='black'
            my='4'
            px={["5px", "20px"]}
            pb='2'
            cursor='pointer'
            w='100%'
            borderBottom='2px solid #eee'
            fontWeight='700'
          >
            {menu.title}
          </Text>
        </Flex>
      </Link>

      {menu.dropdownLinks.map((menu, i) => {
        return (
          <Flex
            align='center'
            w='100%'
            display={showSubMenu ? "flex" : "none"}
            key={i}
          >
            <Box w='100%'>
              <Link to={menu.path}>
                <Text
                  fontSize={["lg", "16px"]}
                  color='black'
                  my='2'
                  px={["5px", "20px"]}
                  cursor='pointer'
                  w='100%'
                  pb='2'
                >
                  {menu.title}
                </Text>
              </Link>
            </Box>
          </Flex>
        );
      })}
    </Flex>
  );
};
